import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
import { module39wmcymxxg0fj as module_0 } from './projects-core-koin-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_preferencesModule() {
  _init_properties_PreferencesCommonModule_kt__9tt7qb();
  return preferencesModule;
}
var preferencesModule;
function preferencesModule$lambda($this$module) {
  _init_properties_PreferencesCommonModule_kt__9tt7qb();
  return Unit_instance;
}
var properties_initialized_PreferencesCommonModule_kt_m7e2u9;
function _init_properties_PreferencesCommonModule_kt__9tt7qb() {
  if (!properties_initialized_PreferencesCommonModule_kt_m7e2u9) {
    properties_initialized_PreferencesCommonModule_kt_m7e2u9 = true;
    preferencesModule = module_0(VOID, preferencesModule$lambda);
  }
}
//region block: exports
export {
  get_preferencesModule as get_preferencesModule2w95kcmis4j4d,
};
//endregion

